import React from "react";
import { arrayOf, bool, shape, string } from "prop-types";
import { Link } from "react-router";
import { Box, CardActionArea, CardContent, Typography } from "@mui/material";
import BaseCard from "./BaseCard";
import DrugList from "./DrugList";
import { urlEncode } from "../utils/url";
import UnpublishedChip from "./UnpublishedChip";
import { isDataSuppressibleForTrial } from "../config";

const ReportSnapshotCard = ({ attributes, searchString = "", subscriptionIsTrial = false }) => {
  const { specific_conditions = [], drugs = [], id, date_of_review, status } = attributes;
  const isUnpublished = status !== "published";
  let path = `/report-snapshots/${id}`;
  if (searchString) {
    path += `?search=${urlEncode(searchString)}`;
  }

  const dateOfReview = new Date(date_of_review);
  let year = "";
  if (date_of_review && specific_conditions) {
    year = ` (${dateOfReview.getFullYear()})`;
  }

  let isSuppressed = subscriptionIsTrial && isDataSuppressibleForTrial(dateOfReview);

  const content = (
    <CardContent sx={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        {specific_conditions.length && (
          <Typography variant="h4" component="h3" sx={{ marginBottom: "30px" }}>
            {specific_conditions[0]}
            {year}
          </Typography>
        )}
        {isUnpublished && <UnpublishedChip />}
        {isSuppressed && (
          <UnpublishedChip
            label="Access restricted"
            tooltipTitle="This report snapshot is not available during the free trial period."
          />
        )}
      </Box>
      {drugs.length > 0 && <DrugList drugs={drugs} darkChips={true} />}
    </CardContent>
  );

  return (
    <BaseCard cardGrows={true} allowHover={!isSuppressed}>
      {!isSuppressed && (
        <CardActionArea
          component={Link}
          to={path}
          disabled={isSuppressed}
          sx={{
            display: "flex",
            flexGrow: 1,
            alignItems: "stretch",
            textDecoration: "none !important",
            "&:hover *": {
              textDecoration: "none !important",
            },
          }}
        >
          {content}
        </CardActionArea>
      )}
      {isSuppressed && content}
    </BaseCard>
  );
};

ReportSnapshotCard.propTypes = {
  attributes: shape({
    specific_conditions: arrayOf(string),
    drugs: arrayOf(string),
    id: string,
    date_of_review: string,
    status: string,
  }).isRequired,
  searchString: string,
  subscriptionIsTrial: bool,
};

export default ReportSnapshotCard;
